import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, HumiLab, DialogueBox } from 'components/UIElements'
import { formatAndSanitizeHTML, replaceInString } from 'utils/misc'
import SurveyQuestion from '../SurveyQuestion'
// import { useFocusOnLoad } from '../../../../utils/animations'
import {
  checkLogicAndComplete,
  getShouldRenderNextQuestion,
} from '../../utils/instrumentUtils'

const completeIntroductionQuestion = props => {
  const {
    question,
    id,
    completeQuestion,
    nextQ,
    webSurvey,
    submissionSurvey,
    nextQId,
    reviewFunctionalitySupported,
    isConsent = false,
    isLastQuestion = false,
    isSibling = false,
  } = props
  const { label, type, attributes } = question
  const { required } = attributes
  const submission = {
    id,
    label,
    name: id,
    type,
    required,
    state: 'REQUIRED',
    answer: []
  }
  const currentAnswer = { [id]: [] }

  const shouldRenderNextQ = getShouldRenderNextQuestion({
    isConsent,
    isLastQuestion,
    isSibling,
  })

  checkLogicAndComplete(
    webSurvey,
    id,
    submissionSurvey,
    currentAnswer,
    nextQId,
    nextQ,
    completeQuestion,
    submission,
    reviewFunctionalitySupported,
    shouldRenderNextQ
  )
}

// const humiNeo = () => {
//   const humiRobo = document.getElementById('neo')
//   const progress = document.getElementsByClassName('meter-outer')[0]
//   progress.classList.add('fly')
//   humiRobo.classList.add('fly-away')
//   setTimeout(() => {
//     navigateTo('/my-activities')
//   }, 4800)
// }

const Introduction = React.forwardRef((props, ref) => {
  const {
    className,
    firstName,
    id,
    onSurveySubmit,
    question,
    strings,
    submission,
    submissionLoading,
    submissionSurvey,
    humiIsabellaDisabled,
    skipIntro
  } = props
  // const buttonRef = useFocusOnLoad()
  const { label = '', attributes = {} } = question
  const { disable_greeting } = attributes
  const _className = className ? ` ${className}` : ''

  useEffect(() => {
    if (!skipIntro) return
    // On resume, suppressAutoAdvance means the path is already restored past intro.
    // Calling nextQ here only advances one step and resets the progress meter.
    if (props.suppressAutoAdvance) return
    completeIntroductionQuestion(props)
  }, [])

  return (
    <div ref={ref}>
      <SurveyQuestion id={id}>
        <HumiLab />
        <DialogueBox
          className={`survey-question introduction${_className}`}
          hasHumi={!humiIsabellaDisabled}
          submission={submission}>
          <div className='scroll-container'>
            {!submission && !disable_greeting && (
              <h3 className='intro-greeting'>
                {firstName
                  ? replaceInString(strings.survey_greeting, '[Name]', firstName)
                  : strings.survey_greeting_generic}
              </h3>
            )}
            <p
              dangerouslySetInnerHTML={{
                __html: formatAndSanitizeHTML(label)
              }}
            />
          </div>
          <Button
            primary
            // ref={buttonRef}
            disabled={submissionLoading}
            className='next'
            content={submission ? strings.survey_finish : strings.survey_begin}
            onClick={() =>
              submission
                ? onSurveySubmit(submissionSurvey)
                : completeIntroductionQuestion(props)
            }
          />
        </DialogueBox>
      </SurveyQuestion>
    </div>
  )
})

export default Introduction

Introduction.propTypes = {
  className: PropTypes.string,
  firstName: PropTypes.string,
  id: PropTypes.string,
  onSurveySubmit: PropTypes.func,
  question: PropTypes.shape({
    label: PropTypes.string,
    attributes: PropTypes.shape({ disable_greeting: PropTypes.bool })
  }),
  strings: PropTypes.objectOf(PropTypes.string),
  submission: PropTypes.bool,
  submissionLoading: PropTypes.bool,
  submissionSurvey: PropTypes.object
}
